import { Injectable } from '@angular/core';

import { ServiceBase } from 'app/shared/infrastructure/serviceBase.component'; // leaf import - do not revert to the barrel (app/shared/infrastructure), breaks ng test (circular dependency)
import { HttpClient } from '@angular/common/http';
import { MedispanServiceApiConfiguration } from '../medispan-service-api-configuration';
import { Observable } from 'rxjs-compat/Observable';

import { Route } from 'app/shared/models/medispan/route';

@Injectable()
export class RouteService extends ServiceBase {

    private actionUrl: string;
    private url: string;
    private getAllUrl: string;
    public queueMonitoring: boolean = false;

    constructor(private _http: HttpClient, private _configuration: MedispanServiceApiConfiguration) {
        super();
        this.actionUrl = _configuration.server;
        this.url = this.actionUrl + _configuration.route.url;
        this.getAllUrl = this.actionUrl + _configuration.route.getAll;
    }

    getAll = (): Observable<Route[]> => {
        return this._http.get<any>(this.getAllUrl)
    }

    isQueueMonitoring = (isQueueComponent = false): void =>{
        this.queueMonitoring = isQueueComponent;
    }

}
